module.exports = __webpack_public_path__ + "static/media/jaminan_uang_kembali.6bcc45b5.png";